import React from 'react';
import PropTypes from 'prop-types';
import ModalTrigger from '../../common/ModalTrigger';
import Finish from '../Finish';
import { analyticsTrack } from '../../../analyticsUtils';
var questionHeader = [{
  header: 'Start Here',
  text: ''
}, {
  header: 'About',
  text: 'Clora sends you projects that align with your level of experience'
}, {
  header: 'Past Experiences',
  text: 'Your past experience is one of the most important criteria that employers review when they evaluate candidates.'
}, {
  header: 'Education',
  text: 'Clora sends you projects that align with the degrees you hold'
}, {
  header: 'Functional Areas',
  text: 'Matching functional areas is one of the primary ways we refine project suggestions for you'
}, {
  header: 'Therapeutic Areas',
  text: 'We improve project suggestions by leveraging therapeutic areas'
}, {
  header: 'Industries and Product Technologies',
  text: "Clora's technology will leverage industries, phases, and product types to further enrich your project suggestions"
}, {
  header: 'Preferences',
  text: "Clora's technology will leverage industries, phases, and product types to further enrich your project suggestions"
}];
function FinishLater(_ref) {
  var _questionHeader$step, _questionHeader;
  var userId = _ref.userId,
    onboardType = _ref.onboardType,
    name = _ref.name,
    step = _ref.step,
    claimInfoUrl = _ref.claimInfoUrl,
    resourceLink = _ref.resourceLink,
    csrfToken = _ref.csrfToken;
  var stepHeader = ((_questionHeader$step = questionHeader[step]) === null || _questionHeader$step === void 0 ? void 0 : _questionHeader$step.header) || ((_questionHeader = questionHeader[step - 1]) === null || _questionHeader === void 0 ? void 0 : _questionHeader.header) || '';
  var _onClick = function onClick() {
    analyticsTrack('Clicking on Finish Later', {
      location: 'Onboarding Flow',
      step: stepHeader,
      userId: userId
    });
  };
  var onClose = function onClose() {
    analyticsTrack('Closing Finish Later', {
      location: 'Onboarding Flow',
      step: stepHeader,
      userId: userId
    });
  };
  return /*#__PURE__*/React.createElement(ModalTrigger, {
    triggerText: "FINISH LATER",
    buttonStyles: "primary text-decoration-none",
    idKey: "claim-your-info-skip-profile-setting-link",
    showFooter: false,
    triggerType: "link",
    onClick: function onClick() {
      return _onClick();
    },
    onCloseCallback: function onCloseCallback() {
      return onClose();
    },
    dialogClassName: "modal-90w",
    cloneContent: true
  }, /*#__PURE__*/React.createElement(Finish, {
    userId: userId,
    claimInfoUrl: claimInfoUrl,
    csrfToken: csrfToken,
    resourceLink: resourceLink,
    name: name,
    step: stepHeader,
    onboardType: onboardType,
    finish: false
  }));
}
FinishLater.propTypes = {
  onboardType: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  step: PropTypes.number.isRequired,
  resourceLink: PropTypes.string.isRequired,
  csrfToken: PropTypes.string.isRequired,
  userId: PropTypes.string.isRequired,
  claimInfoUrl: PropTypes.string.isRequired
};
export default FinishLater;